<template>
  <div class="p-4">
    <h2>Redeem Gift Cards</h2>
    Select the gift cards you would like applied to the customers balance.
    <div v-for="giftCard in giftCards">
      <hr />
      <div style="display:flex">
        <div>
          <b-checkbox v-model="giftCard.isSelected" size="lg" />
        </div>
        <div
          @click="giftCard.isSelected = !giftCard.isSelected"
          style="cursor:pointer"
        >
          <div class="h2">{{ (giftCard.amount / 100) | currency }}</div>
          <div class="text-muted">
            {{ giftCard.redemptionCode }}<br />
            <small> {{ giftCard.created | moment("MM/DD/YYYY") }}</small> -
            <small> {{ giftCard.created | moment("from") }}</small>
          </div>
        </div>
      </div>
    </div>
    <b-button class="mt-4" block variant="primary" @click="redeem"
      >Redeem Gift Cards</b-button
    >
  </div>
</template>

<script>
export default {
  props: { customer: null },
  data() {
    return {
      ids: [],
      giftCards: null,
    };
  },

  async created() {
    let r = await this.$client.get(
      "/api/giftcard/getUnRedeemedGiftCards?customerId=" + this.customer.id
    );

    r.data.value.giftCards.forEach((giftCard) => {
      giftCard.isSelected = true;
    });

    if (r.data.isSuccess) {
      this.giftCards = r.data.value.giftCards;
    }
  },
  methods: {
    async redeem() {
      let ids = this.giftCards.filter((g) => g.isSelected).map((g) => g.id);

      if (ids.length == 0) {
        this.$emitter.emit("error", "You must select one gift card.");
        return;
      }

      let r = await this.$client.post("/api/giftcard/redeemCards", {
        GiftCardIds: ids,
      });

      if (r.data.isSuccess) {
        this.$emitter.emit("success-confirm", {
          title: "Gift Cards Redeemed",
          message:
            "The gift cards have been redeemed, and applied to the customer's balance.",
        });
        this.$emit("refreshCustomer");
      }
    },
  },
};
</script>

<style></style>
